import { deleteWithPayload, get, post } from "../../../shared/data";
import { filterConfig, getFilterParams } from "./constants";

export const getSortParams = (sorts) => {
    const paramSorted = sorts.map((sort) => {
        const id = sort.id.split(".").pop();
        const ascDesc = sort.desc ? "desc" : "asc";

        return `&sortBy=${id}&orderBy=${ascDesc}`;
    });

    return paramSorted.length > 0 ? paramSorted.join(",") : "";
};

export const searchUsers = (payload) => {
    return post("/users/search", payload);
};

export const getUsers = (pageNumber = 1, pageSize, sort, filter) => {
    const sortBy = getSortParams(sort);
    const filterBy = getFilterParams(filter, filterConfig);

    return get(`/users?pagesize=${pageSize}&pagenumber=${pageNumber}${sortBy}${filterBy}`);
};

export const getUser = (id) => {
    const url = `/users/${id}`;

    return get(url);
};

export const getUserPermissions = (id, pageNumber = 1, pageSize, sort, filter) => {
    const sortBy = getSortParams(sort);
    const filterBy = getFilterParams(filter, filterConfig);
    const url = `/users/${id}/permissions?pagesize=${pageSize}&pagenumber=${pageNumber}${sortBy}${filterBy}`;

    return get(url);
};

export const getUserRoles = (id, pageNumber = 1, pageSize, sort, filter) => {
    const sortBy = getSortParams(sort);
    const filterBy = getFilterParams(filter, filterConfig);
    const url = `/users/${id}/roles?pagesize=${pageSize}&pagenumber=${pageNumber}${sortBy}${filterBy}`;

    return get(url);
};

export const addRoleToUser = (userId, roleId) => {
    const payload = { roleIds: [roleId] };

    return post(`/users/${userId}/roles`, payload);
};

export const deleteRoleFromUser = (userId, roleId) => {
    const payload = { roleIds: [roleId] };

    return deleteWithPayload(`/users/${userId}/roles`, payload);
};

export const addUserInfo = (userId, roleId, groupId) => {
    const payload = { roleIds: [roleId], groupAssignmentKeys: [groupId] };

    return post(`/users/${userId}`, payload);
};

export const getAvailableUserAssignmentGroups = (type = "") => {
    return get(`/user-assignment-groups/users?taskType=${type}`);
};
